export default __webpack_public_path__ + "static/media/gb-wls.8e324fcd.svg";